import styled from 'styled-components';

import StarsList from '@/components/Base/StarsList';
import { mediaQueryLaptopMin, mediaQueryMobileLargeMin } from '@/styleUtils';

export const Wrapper = styled.div`
  display: inline-flex;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    top: -16px;
    bottom: -16px;
    left: -16px;
    right: -16px;
    z-index: 1;
  }

  @media ${mediaQueryLaptopMin} {
    &:after {
      top: -8px;
      bottom: -8px;
      left: -8px;
      right: -8px;
    }
  }
`;

export const ProductCompanyRatingValue = styled(StarsList)`
  margin-left: auto;

  @media ${mediaQueryMobileLargeMin} {
    margin-left: 0;
  }
`;
